import type {
  GetFeetCharacteristicsRequest,
  GetFeetCharacteristicsResponse,
} from '~/api/aspida/@types';
import { sendRequest } from '~/api/sendRequest';

export const getFeetCharacteristics = sendRequest<
  GetFeetCharacteristicsRequest,
  GetFeetCharacteristicsResponse
>({
  url: '/feet_characteristics',
  method: 'get',
});
